import React, { createContext, useState } from 'react';

export const PopupContext = createContext();
PopupContext.displayName = 'PopupContext';

const PopupContextProvider = ({ children, state }) => (
  <PopupContext.Provider value={state}>{children}</PopupContext.Provider>
);

const PopupStateProvider = ({ children }) => {
  const [popupId, setPopupId] = useState(null);

  const contextValues = {
    popupId,
    setPopupId,
  };

  return <PopupContextProvider state={contextValues}>{children}</PopupContextProvider>;
};

export default PopupStateProvider;
